import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import { BookOpen } from 'lucide-react';
import { api } from '../services/api';

interface VersionInfo { base: string; sha: string; version: string; }

const AboutPage: React.FC = () => {
  const [v, setV] = useState<VersionInfo | null>(null);
  useEffect(() => { api<VersionInfo>('/api/version').then(setV).catch(() => {}); }, []);

  return (
    <div className="min-h-screen bg-gray-900 text-gray-100">
      <header className="bg-gray-800 border-b border-gray-700 px-4 sm:px-6 py-4 flex items-center gap-3">
        <Link to="/" className="text-gray-400 hover:text-white flex items-center gap-1">
          <BookOpen className="w-5 h-5" /> Hausaufgabenheft
        </Link>
        <span className="text-gray-600">·</span>
        <h1 className="text-xl font-semibold">Über dieses Projekt</h1>
      </header>

      <main className="max-w-3xl mx-auto p-4 sm:p-6 space-y-8">
        <section className="bg-gray-800 border border-gray-700 rounded-lg p-6 text-center">
          <a href="https://vtrust.de" target="_blank" rel="noreferrer" className="inline-block mb-4">
            <img
              src="https://vtrust.de/wp-content/uploads/vtrust_breit_neg_rgb_small.png"
              alt="VTRUST — Smart Technology"
              className="mx-auto h-12 w-auto"
            />
          </a>
          <h2 className="text-2xl font-bold text-white mb-2">Hausaufgabenheft</h2>
          <p className="text-gray-400">Ein Schulportal-Begleiter, entstanden am Girls'Day.</p>
        </section>

        <section className="bg-gray-800 border border-gray-700 rounded-lg p-6 space-y-4 text-gray-300 leading-relaxed">
          <p>
            Dieses Projekt ist am <strong>Girls'Day</strong> bei der{' '}
            <a href="https://vtrust.de" target="_blank" rel="noreferrer" className="text-blue-400 hover:text-blue-300">
              VTRUST GmbH
            </a>{' '}
            entstanden.
          </p>
          <p>
            Es wurde von <strong>Maila Schmittner</strong> inspiriert und mitgestaltet — mit dem Ziel,
            den Alltag rund um das Schüler-Portal am Hanns-Seidel-Gymnasium Hösbach etwas einfacher
            zu machen. Aus ihrer Perspektive ist das Heft gewachsen: welche Informationen sind
            wichtig, was soll sofort sichtbar sein, was stört, was fehlt.
          </p>
          <p>
            Aus einer Schnupper-Idee wurde ein echter digitaler Hausaufgaben-Begleiter mit Stundenplan,
            Hausaufgaben-Tracking, Zeiterfassung, Noten-Verwaltung, Terminen und einem Kalender-Abo
            für Apple Calendar &amp; Co.
          </p>
          <p className="text-sm text-gray-400 border-t border-gray-700 pt-4">
            Danke an VTRUST für den Tag, die Technik, den Kaffee und die Möglichkeit.
          </p>
        </section>

        <section className="bg-gray-800 border border-gray-700 rounded-lg p-6">
          <h3 className="font-semibold mb-3">Rechtliches</h3>
          <div className="flex flex-wrap gap-4 text-sm">
            <Link to="/impressum" className="text-blue-400 hover:text-blue-300">Impressum</Link>
            <Link to="/datenschutz" className="text-blue-400 hover:text-blue-300">Datenschutzhinweise</Link>
            <a href="https://vtrust.de/impressum" target="_blank" rel="noreferrer" className="text-blue-400 hover:text-blue-300">VTRUST Impressum</a>
            <a href="https://github.com/vtrust-de/hausaufgabenheft" target="_blank" rel="noreferrer" className="text-blue-400 hover:text-blue-300">Source (privat)</a>
          </div>
          {v && (
            <p className="text-xs text-gray-500 mt-4">
              Version <code className="text-gray-400">{v.version}</code>
            </p>
          )}
        </section>
      </main>
    </div>
  );
};

export default AboutPage;
